import { Theme } from '@app/theme';
import { createUseStyles } from 'react-jss';
import {
  OfferProduct,
  useCountriesFromKeys,
  useCountryPriceTiers,
  usePriceGroupByCountries,
} from 'queries';
import { PriceChips } from '../PriceChips';
import { useMemo } from 'react';
import { Chip } from '@app/core';
import { getGroupProducts } from 'lib/planAndOffer';

interface Props {
  products: OfferProduct[];
  offerName?: string;
  duration?: number;
  countryKeys: string[];
}

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    gap: theme.marginBase,
    flexDirection: 'column',
  },
  line: {
    backgroundColor: theme.colors.grayBackground,
    borderRadius: theme.borderRadius.std,
    padding: theme.marginBase,

    display: 'flex',
    alignItems: 'center',
    gap: theme.marginBase,
    flexWrap: 'wrap',
  },
  country: {
    flex: 1,
    minWidth: 150,
  },
}));

export const PricesByCountries = ({
  products,
  offerName,
  duration = 60,
  countryKeys,
}: Props) => {
  const classes = useStyles();

  const groupByCountry = usePriceGroupByCountries();
  const countryGroups = useCountryPriceTiers(countryKeys);
  const countries = useCountriesFromKeys(countryKeys);

  const productsByGroup = useMemo(() => {
    const res: Record<string, OfferProduct[]> = {};
    for (const group of countryGroups) {
      res[group] = getGroupProducts(products, group);
    }
    return res;
  }, [countryGroups, products]);

  return (
    <div className={classes.container}>
      {countries.map(
        (country) =>
          !!groupByCountry[country.key] && (
            <div className={classes.line}>
              <div className={classes.country}>
                <Chip color="green">{country?.text}</Chip>
              </div>
              <PriceChips
                products={productsByGroup[groupByCountry[country.key]!]}
                duration={duration}
                offerName={offerName}
                overGray
                ink
              />
            </div>
          ),
      )}
    </div>
  );
};
